import React from 'react';
import { Provider } from 'react-redux';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';
import GlobalSessionHandle from 'components/GlobalSessionExpiry';
import { FeatureFlagsProvider } from 'components/FeatureFlags';
import { hot } from 'react-hot-loader';
import ForgotPasswordContainer from './ForgotPasswordContainer';
import configureStore from '../stores';

function Root() {
    return (
        <Provider store={configureStore()}>
            <GlobalErrorBoundary>
                <GlobalSessionHandle>
                    <FeatureFlagsProvider>
                        <ForgotPasswordContainer />
                    </FeatureFlagsProvider>
                </GlobalSessionHandle>
            </GlobalErrorBoundary>
        </Provider>
    );
}

export default hot(module)(Root);
